import React from 'react';
import AlertManagerInitializer from '../components/AlertManager/AlertManagerInitializer';
import ManageAlertsPageStyleLoader from './ManageAlertsPageStyleLoader';

function ManageAlertsPage() {
  return (
    <ManageAlertsPageStyleLoader>
      <div className="manage-alerts-page">
        {/* The AlertManagerInitializer will render the manager which includes its own title logic via hideTitle */}
        <AlertManagerInitializer hideTitle={false} />
      </div>
    </ManageAlertsPageStyleLoader>
  );
}

export default ManageAlertsPage;
